import { render, staticRenderFns } from "./TopSellingCompanies.vue?vue&type=template&id=de532158&scoped=true&"
import script from "./TopSellingCompanies.vue?vue&type=script&lang=js&"
export * from "./TopSellingCompanies.vue?vue&type=script&lang=js&"
import style0 from "./TopSellingCompanies.vue?vue&type=style&index=0&id=de532158&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de532158",
  null
  
)

export default component.exports